// FE-084 — contatore «Mostrati N di M» sempre visibile e pulsante «Carica altri».
// Il contatore e' la meta' che conta: il difetto era che l'elenco TACEVA sul
// resto dei documenti.
import { testoContatore } from '../../pages/documenti/archivioBlocchi';

export default function CaricaAltri({ elenco }) {
  if (!elenco || !elenco.mostraContatore) return null;
  return (
    <div data-testid="archivio-carica-altri" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, flexWrap: 'wrap', padding: '14px 0 4px' }}>
      <span data-testid="archivio-contatore" style={{ fontSize: 12, color: 'var(--ds-muted)' }}>
        {testoContatore(elenco.docs.length, elenco.totale)}
      </span>
      {elenco.ciSonoAltri && (
        <button
          type="button"
          onClick={elenco.caricaAltri}
          disabled={elenco.loadingAltri}
          style={{ minHeight: 44, padding: '0 18px', borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ds-text)', cursor: elenco.loadingAltri ? 'default' : 'pointer', fontSize: 13, fontWeight: 500 }}
        >
          {elenco.loadingAltri ? 'Caricamento…' : 'Carica altri'}
        </button>
      )}
      {elenco.errorAltri && (
        <span role="alert" style={{ fontSize: 12, color: 'var(--ds-danger)' }}>{elenco.errorAltri}</span>
      )}
    </div>
  );
}
